import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {PaymentRequestReminderItemComponent} from "./payment-request-reminder-item.component";
import {ItemModule} from "../../../../../../../core/component/item/item.module";
import {PaymentRequestReminderSummaryModule} from "../payment-request-reminder-summary/payment-request-reminder-summary.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        PaymentRequestReminderSummaryModule,
        ItemModule
    ],
    declarations: [
        PaymentRequestReminderItemComponent,
    ],
    exports: [
        PaymentRequestReminderItemComponent
    ],
})
export class PaymentRequestReminderItemModule {
}
